import { Input } from "@/components/ui/input"
import { Card } from "@/components/ui/card"
import { useFormContext } from "react-hook-form"
import {
	FormControl,
	FormField,
	FormItem,
	FormMessage
} from "@/components/ui/form"
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow
} from "@/components/ui/table"

type MeasurementData = {
	name : string
	label : string
	acronym : string
	measures : string
}

const measurements : MeasurementData[] = [
	{
		name: "length_of_rump",
		label: "Length of Rump",
		acronym: "LP",
		measures: "Length from hip to pin bones (CG)",
	},
	{
		name: "height_of_rump",
		label: "Height of Rump",
		acronym: "AG",
		measures: "Vertical distance from the ground to the top of the rump",
	},
	{
		name: "lower_height",
		label: "Lower Height",
		acronym: "LH",
		measures: "ALTURA INFERIOR - Distance from ground to bottom of chest",
	},
	{
		name: "back_height",
		label: "Back Height",
		acronym: "BH",
		measures: "Height at withers (AG)",
	},
	{
		name: "body_length",
		label: "Body Length",
		acronym: "BL",
		measures: "Length from point of shoulder to pin bone (CC)",
	},
	{
		name: "rib_depth",
		label: "Rib Depth",
		acronym: "RD",
		measures: "Depth of rib cage (PC)",
	},
	{
		name: "chest_perimeter",
		label: "Chest Perimeter",
		acronym: "CP",
		measures: "Circumference of chest behind shoulders (PT)",
	},
	{
		name: "body_width",
		label: "Body Width",
		acronym: "BW",
		measures: "Width between hip bones (LG)",
	},
	{
		name: "scrotal_circumference",
		label: "Scrotal Circumference",
		acronym: "SC",
		measures: "Circumference of scrotum (CE)",
	},
]

export function BodyMeasurementsForm () {
	const { control } = useFormContext ()

	return (
			<div className="space-y-6" >
				<h2 className="text-2xl font-bold text-center mb-6" >Body
				                                                     Measurements</h2 >

				<Table >
					<TableHeader >
						<TableRow >
							<TableHead
									className="w-[200px]" >Measurement</TableHead >
							<TableHead
									className="w-[100px]" >Acronym</TableHead >
							<TableHead >Value</TableHead >
							<TableHead
									className="hidden md:table-cell" >Measures</TableHead >
						</TableRow >
					</TableHeader >
					<TableBody >
						{ measurements.map ( ( measurement ) => (
								<TableRow key={ measurement.name } >
									<TableCell
											className="font-medium" >{ measurement.label }</TableCell >
									<TableCell >{ measurement.acronym }</TableCell >
									<TableCell >
										<FormField
												control={ control }
												name={ measurement.name }
												render={ ( { field } ) => (
														<FormItem className="space-y-0" >
															<FormControl >
																<Input
																		type="number"
																		step="0.1"
																		placeholder="Enter value"
																		{ ...field }
																		onChange={ ( e ) => field.onChange ( e.target.value ? Number ( e.target.value ) : undefined ) }
																		className="w-full"
																/>
															</FormControl >
															<FormMessage />
														</FormItem >
												) }
										/>
									</TableCell >
									<TableCell
											className="hidden md:table-cell text-sm text-muted-foreground" >
										{ measurement.measures }
									</TableCell >
								</TableRow >
						) ) }
					</TableBody >
				</Table >

				<Card
						className="p-4 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700" >
					<p className="text-sm text-slate-600 dark:text-slate-400" >
						Body measurements provide important data for
						evaluating structural correctness, growth potential,
						and breeding
						capability. These measurements are taken at specific
						anatomical points and help in standardized
						evaluation.
					</p >
				</Card >
			</div >
	)
}
